export function formatDate(dateStr: string) {
  const date = new Date(dateStr)

  // Extract and format the components
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0') // Months are 0-indexed
  const year = String(date.getFullYear()).slice(2)

  return `${day}.${month}.${year}`
}

export function formatTime(dateStr: string) {
  const date = new Date(dateStr)
  const hours = String(date.getUTCHours()).padStart(2, '0')
  const minutes = String(date.getUTCMinutes()).padStart(2, '0')
  const seconds = String(date.getUTCSeconds()).padStart(2, '0')

  return `${hours}:${minutes}:${seconds}`
}
